import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    typeLists: []
};
const getters = {
    manneType: state => state.typeLists

};

const mutations = {
    MANNE_TYPE_INFO(state, data) {
        state.typeLists = data
    }
};

const actions = {
    manneType(context) {
        axiosGet(`crm/manne/types`).then((response) => {
            context.commit('MANNE_TYPE_INFO', response.data.data)
        }).catch((error) => console.log(error));
    }
};


export default {
    state,
    getters,
    mutations,
    actions
}
